import Vue from 'vue'
import Swiper from 'swiper'
import 'swiper/swiper-bundle.css'

Vue.prototype.$swiper = Swiper
